import { render, staticRenderFns } from "./archived-mailings-stats-general-table-filter.vue?vue&type=template&id=35e1b27a&"
import script from "./archived-mailings-stats-general-table-filter.vue?vue&type=script&lang=js&"
export * from "./archived-mailings-stats-general-table-filter.vue?vue&type=script&lang=js&"
import style0 from "./archived-mailings-stats-general-table-filter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports